import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}